<div data-testid="expiry-timeline" class="expiry-timeline">
  <div class="expiry-timeline__header">
    <div class="expiry-timeline__titles">
      <h4 data-testid="expiry-title" class="expiry-timeline__title">{{ title }}</h4>
      <p data-testid="expiry-description" class="expiry-timeline__description">{{ headline }}</p>
    </div>
  </div>
  @if (failed) {
    <app-admin-dashboard-empty data-testid="expiry-failed" icon="fa-regular fa-circle-exclamation" [title]="failedTitle"
                               body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
  } @else if (notApplicable) {
    <div data-testid="expiry-na" class="expiry-timeline__chart expiry-timeline__na">
      <app-admin-dashboard-empty icon="fa-regular fa-address-card" title="No Client Manager record"></app-admin-dashboard-empty>
    </div>
  } @else if (loaded) {
    <div #chart data-testid="expiry-timeline-chart" class="expiry-timeline__chart" role="img"
         aria-label="Licence value by days until the licence ends"></div>
  } @else {
    <div class="expiry-timeline__chart"></div>
  }
</div>
